(() => {
  const root = document.querySelector('[data-teacher-form]')?.closest('[data-submit-endpoint]');
  if (!root) return;
  const form = root.querySelector('[data-teacher-form]');
  const success = root.querySelector('[data-success]');
  const formMessage = root.querySelector('[data-form-message]');
  let originalSubmit = form.onsubmit;
  let confirmedDuplicate = false;
  let submitting = false;

  const stateInput = form.elements.state;
  if (stateInput && !form.elements.postal_code) {
    const postalLabel = document.createElement('label');
    postalLabel.innerHTML = 'Postal code <em>*</em><input name="postal_code" required autocomplete="postal-code">';
    stateInput.closest('label')?.after(postalLabel);
  }

  const phoneLabel = form.elements.phone_local?.closest('label');
  phoneLabel?.querySelector('em')?.remove();
  form.elements.phone_local?.removeAttribute('required');

  const postalField = form.elements.postal_code?.closest('label');
  if (postalField && !form.elements.privacy_protection) {
    const privacyLabel = document.createElement('div');
    privacyLabel.className = 'teacher-privacy-toggle';
    privacyLabel.innerHTML = '<input type="checkbox" name="privacy_protection" value="true" data-privacy-toggle><span>Privacy protection:</span>';
    const coverageLabel = document.createElement('label');
    coverageLabel.className = 'teacher-service-coverage';
    coverageLabel.dataset.serviceCoverageField = '';
    coverageLabel.hidden = true;
    coverageLabel.innerHTML = 'Service coverage area <em>*</em><input name="service_coverage_area" autocomplete="address-level2" placeholder="City or service area">';
    postalField.after(privacyLabel, coverageLabel);
  }

  const picker = form.querySelector('[data-phone-picker]');
  const phoneCountry = picker?.querySelector('[name="phone_country"]');
  const phoneMenu = picker?.querySelector('[data-phone-menu]');
  const phoneSearch = picker?.querySelector('[data-phone-search]');
  const phoneOptions = picker?.querySelector('[data-phone-options]');
  const phoneSelected = picker?.querySelector('[data-phone-selected]');
  const countries = [['🇺🇸','United States','+1'],['🇨🇦','Canada','+1'],['🇲🇽','Mexico','+52'],['🇬🇧','United Kingdom','+44'],['🇫🇷','France','+33'],['🇩🇪','Germany','+49'],['🇪🇸','Spain','+34'],['🇮🇹','Italy','+39'],['🇦🇺','Australia','+61'],['🇳🇿','New Zealand','+64'],['🇮🇳','India','+91'],['🇨🇳','China','+86'],['🇯🇵','Japan','+81'],['🇰🇷','South Korea','+82'],['🇸🇬','Singapore','+65'],['🇧🇷','Brazil','+55'],['🇿🇦','South Africa','+27'],['🇦🇪','United Arab Emirates','+971'],['🇹🇷','Türkiye','+90'],['🇮🇱','Israel','+972'],['🇵🇭','Philippines','+63'],['🇹🇭','Thailand','+66'],['🇻🇳','Vietnam','+84'],['🇭🇰','Hong Kong','+852']];
  const drawPhoneOptions = () => { const query = (phoneSearch?.value || '').toLowerCase(); if (phoneOptions) phoneOptions.innerHTML = countries.filter(country => (country[1] + country[2]).toLowerCase().includes(query)).map(country => `<button type="button" data-code="${country[2]}" data-label="${country[0]} ${country[2]}">${country[0]} ${country[1]} <b>${country[2]}</b></button>`).join(''); };
  phoneSelected?.addEventListener('click', () => { phoneMenu.hidden = !phoneMenu.hidden; if (!phoneMenu.hidden) { drawPhoneOptions(); phoneSearch.focus(); } });
  phoneSearch?.addEventListener('input', drawPhoneOptions);
  phoneOptions?.addEventListener('click', event => { const option = event.target.closest('button'); if (!option) return; phoneCountry.value = option.dataset.code; phoneSelected.textContent = option.dataset.label; phoneMenu.hidden = true; });
  document.addEventListener('click', event => { if (picker && !picker.contains(event.target)) phoneMenu.hidden = true; });

  const fields = ['full_name','email','street_address','city','state','postal_code'];
  const labels = { full_name:'full name', email:'email address', street_address:'street address', city:'city', state:'state', postal_code:'postal code', service_coverage_area:'service coverage area' };
  const bio = form.elements.teacher_bio;
  const bioCounter = form.querySelector('[data-bio-counter]');
  bio?.setAttribute('maxlength', '800');
  bio?.removeAttribute('required');
  bio?.closest('label')?.querySelector('em')?.remove();
  form.querySelector('.teacher-format > strong em')?.remove();
  const updateBioCounter = () => {
    if (bio.value.length > 800) bio.value = bio.value.slice(0, 800);
    if (bioCounter) bioCounter.textContent = `${bio.value.length}/800`;
  };
  bio?.addEventListener('input', updateBioCounter);
  updateBioCounter();

  if (!originalSubmit) {
    originalSubmit = async event => {
      const data = new FormData(form);
      const code = String(data.get('phone_country') || '').replace(/\D/g, '');
      const local = String(data.get('phone_local') || '').replace(/\D/g, '');
      const payload = Object.fromEntries(data);
      payload.tags = data.getAll('tags');
      payload.teaching_format = data.getAll('teaching_format');
      payload.phone = local ? `(+${code})${local}` : '';
      payload.show_specific_location = String(!form.elements.privacy_protection?.checked);
      delete payload.privacy_protection;
      delete payload.phone_country;
      delete payload.phone_local;
      const response = await fetch(root.dataset.submitEndpoint, { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({ type:'teacherdata', data:payload }) });
      if (!response.ok) {
        let detail = '';
        try { detail = (await response.json())?.error || ''; } catch (_) {}
        const submitError = new Error(response.status === 404 ? 'ENDPOINT_NOT_FOUND' : 'SUBMIT_FAILED');
        submitError.detail = detail;
        throw submitError;
      }
      form.hidden = true;
      success.hidden = false;
    };
  }
  const error = (name, message) => {
    const input = form.elements[name];
    if (!input) return;
    let el = form.querySelector(`[data-error-for="${name}"]`);
    if (!el) { el = document.createElement('span'); el.dataset.errorFor = name; el.style.cssText = 'display:block;color:#b42318;font-size:13px;margin-top:4px'; input.closest('label')?.append(el); }
    el.textContent = message;
  };
  const clear = name => form.querySelector(`[data-error-for="${name}"]`)?.remove();
  fields.forEach(name => form.elements[name]?.addEventListener('input', () => clear(name)));
  form.elements.state?.addEventListener('change', () => clear('state'));
  const privacyToggle = form.elements.privacy_protection;
  const coverageField = form.querySelector('[data-service-coverage-field]');
  const coverageInput = form.elements.service_coverage_area;
  const syncPrivacyFields = () => {
    const protectedLocation = Boolean(privacyToggle?.checked);
    if (coverageField) coverageField.hidden = !protectedLocation;
    if (coverageInput) coverageInput.required = protectedLocation;
  };
  privacyToggle?.addEventListener('change', () => { clear('service_coverage_area'); syncPrivacyFields(); });
  coverageInput?.addEventListener('input', () => clear('service_coverage_area'));
  syncPrivacyFields();

  form.onsubmit = async event => {
    event.preventDefault();
    if (submitting) return;
    updateBioCounter();
    submitting = true;
    const submitButton = form.querySelector('.teacher-submit');
    const resetSubmitState = () => { submitting = false; if (submitButton) submitButton.disabled = false; };
    if (submitButton) submitButton.disabled = true;
    let invalid = false;
    fields.forEach(name => { if (!String(form.elements[name]?.value || '').trim()) { error(name, `Please enter your ${labels[name]}.`); invalid = true; } });
    if (privacyToggle?.checked && !String(coverageInput?.value || '').trim()) { error('service_coverage_area', `Please enter your ${labels.service_coverage_area}.`); invalid = true; }
    const email = String(form.elements.email.value || '').trim().toLowerCase();
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { error('email', 'Please enter a valid email address.'); invalid = true; }
    const phoneLocalValue = String(form.elements.phone_local?.value || '').trim();
    if (phoneLocalValue && !/^\+?[0-9 ()-]{7,}$/.test(phoneLocalValue)) { error('phone_local', 'Please enter a valid phone number.'); invalid = true; }
    if (invalid) { submitting = false; if (submitButton) submitButton.disabled = false; (form.querySelector('[data-error-for]') || form.elements.email).scrollIntoView({ behavior:'smooth', block:'center' }); return; }

    if (!confirmedDuplicate) {
      try {
        const check = await fetch(root.dataset.submitEndpoint, { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({ action:'check_email', email }) });
        if (!check.ok) {
          confirmedDuplicate = true;
        } else {
          const result = await check.json();
          if (result.exists && !window.confirm('This email has already been submitted.\n\nWould you like to submit the information again and create a new application?\n\nChoose OK to Submit Again or Cancel to edit your information.')) { resetSubmitState(); return; }
          confirmedDuplicate = Boolean(result.exists);
        }
      } catch (_) {
        resetSubmitState();
        if (formMessage) formMessage.textContent = 'We could not validate your application. Please check your connection and try again.';
        return;
      }
    }
    const requestId = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const remarks = confirmedDuplicate
      ? `${new Date().toLocaleString('zh-CN', { hour12: false })}，用户重复提交数据`
      : '';
    if (confirmedDuplicate) {
      const code = String(form.elements.phone_country?.value || '').replace(/\D/g, '');
      const phone = `(+${code})${String(form.elements.phone_local?.value || '').replace(/\D/g, '')}`;
      localStorage.removeItem(`mahjcove-teacher-${email}-${phone}`);
    }
    const originalFetch = window.fetch;
    window.fetch = (input, init) => {
      if (init?.body && typeof init.body === 'string') {
        try {
          const payload = JSON.parse(init.body);
          payload.request_id = requestId;
          if (remarks && payload.data) payload.data.remarks = remarks;
          init = { ...init, body: JSON.stringify(payload) };
        } catch (_) {}
      }
      return originalFetch(input, init);
    };
    try {
      await originalSubmit(event);
    } catch (error) {
      resetSubmitState();
      if (formMessage) formMessage.textContent = error.message === 'ENDPOINT_NOT_FOUND'
        ? 'The application service is not configured yet. Please contact us directly.'
        : (error.detail || 'We could not submit your application. Please check your information and try again.');
      return;
    } finally {
      window.fetch = originalFetch;
    }
    if (success && !success.hidden) success.scrollIntoView({ behavior:'smooth', block:'center' });
  };
})();
